import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#020C1B",
              border: "1px solid rgba(212, 175, 55, 0.35)",
              color: "#F8FAFC",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
